import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import {
  useGetThreadQuery,
  useDownvoteThreadMutation,
  useNeutralizeThreadMutation,
  useUpvoteThreadMutation,
} from '../../store/api/threadsApi';
import { ContentBody } from '../pieces/ContentBody';
import { ThreadFooter } from '../pieces/ThreadFooter';
import { DirectHeader } from './threadDetail/DirectHeader';

export function DirectThreadDetail() {
  const { threadId } = useParams();
  const location = useLocation();
  const { isLoading, data: threadDetail } = useGetThreadQuery(threadId);
  const { status, currentUser } = useSelector((state) => state.auth);
  const authenticated = status === 'authenticated';

  const [isUpvoted, setIsUpvoted] = useState(false);
  const [isDownvoted, setIsDownvoted] = useState(false);

  const [upvoteThread] = useUpvoteThreadMutation();
  const [downvoteThread] = useDownvoteThreadMutation();
  const [neutralizeVote] = useNeutralizeThreadMutation();

  const onUpvoteButtonClick = () => {
    if (authenticated && isUpvoted) {
      const newUpvotesBy = threadDetail.upVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      neutralizeVote({
        threadId: threadDetail.id,
        newUpvotesBy,
        newDownvotesBy: threadDetail.downVotesBy,
      });
    } else if (authenticated && !isDownvoted) {
      const newUpvotesBy = [...threadDetail.upVotesBy, currentUser.id];
      upvoteThread({ threadId: threadDetail.id, newUpvotesBy });
    } else if (authenticated && isDownvoted) {
      const newDownvotesBy = threadDetail.downVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      const newUpvotesBy = [...threadDetail.upVotesBy, currentUser.id];
      neutralizeVote({
        threadId: threadDetail.id,
        newUpvotesBy,
        newDownvotesBy,
      });
      upvoteThread({ threadId: threadDetail.id, newUpvotesBy });
    } else {
      document.getElementById('loginDialog').showModal();
    }
  };

  const onDownvoteButtonClick = () => {
    if (authenticated && isDownvoted) {
      const newDownvotesBy = threadDetail.downVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      neutralizeVote({
        threadId: threadDetail.id,
        newUpvotesBy: threadDetail.upVotesBy,
        newDownvotesBy,
      });
    } else if (authenticated && !isUpvoted) {
      const newDownvotesBy = [...threadDetail.downVotesBy, currentUser.id];
      downvoteThread({ threadId: threadDetail.id, newDownvotesBy });
    } else if (authenticated && isUpvoted) {
      const newUpvotesBy = threadDetail.upVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      const newDownvotesBy = [...threadDetail.downVotesBy, currentUser.id];
      neutralizeVote({
        threadId: threadDetail.id,
        newUpvotesBy,
        newDownvotesBy,
      });
      downvoteThread({
        threadId: threadDetail.id,
        newUpvotesBy,
        newDownvotesBy,
      });
    } else {
      document.getElementById('loginDialog').showModal();
    }
  };

  const onCommentButtonClick = () => {
    if (authenticated && location.pathname.includes('/t/')) {
      document.getElementById('commentInput').focus();
    } else if (!authenticated) {
      document.getElementById('loginDialog').showModal();
    }
  };

  const baseUrl = window.location.origin;
  let sharedData;
  if (!isLoading) {
    sharedData = {
      url: `${baseUrl}/t/${threadDetail.id}`,
      text: `${
        threadDetail.body.length >= 100
          ? threadDetail.body.substring(0, 239).concat('...')
          : threadDetail.body
      }`,
      title: threadDetail.title,
    };
  }

  const onShareButtonClick = () => {
    if (isSecureContext) {
      navigator.share(sharedData);
    } else {
      alert(
        'You cant do this in unsecured access. Share it from browser address bar instead.'
      );
    }
  };

  useEffect(() => {
    if (
      currentUser &&
      threadDetail &&
      threadDetail.upVotesBy.includes(currentUser.id)
    ) {
      setIsUpvoted(true);
    }
    if (
      currentUser &&
      threadDetail &&
      !threadDetail.upVotesBy.includes(currentUser.id)
    ) {
      setIsUpvoted(false);
    }
    if (
      currentUser &&
      threadDetail &&
      threadDetail.downVotesBy.includes(currentUser.id)
    ) {
      setIsDownvoted(true);
    }
    if (
      currentUser &&
      threadDetail &&
      !threadDetail.downVotesBy.includes(currentUser.id)
    ) {
      setIsDownvoted(false);
    }
  }, [currentUser, threadDetail]);
  return (
    <article className="group">
      {isLoading ? (
        <div>Loading....</div>
      ) : (
        <>
          <DirectHeader
            title={threadDetail.title}
            ownerAva={threadDetail.owner.avatar}
            ownerId={threadDetail.owner.id}
            ownerName={threadDetail.owner.name}
            category={threadDetail.category}
            createdAt={threadDetail.createdAt}
          />
          <ContentBody text={threadDetail.body} />
          <ThreadFooter
            upvotes={threadDetail.upVotesBy}
            downvotes={threadDetail.downVotesBy}
            isUpvoted={isUpvoted}
            isDownvoted={isDownvoted}
            commentsCount={threadDetail.comments.length}
            handleCommentAction={onCommentButtonClick}
            handleUpvoteAction={onUpvoteButtonClick}
            handleDownvoteAction={onDownvoteButtonClick}
            handleShareAction={onShareButtonClick}
          />
        </>
      )}
    </article>
  );
}
